import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _Questions;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var EDUCATION_STATUS_KEYS = ['Graduated', 'Studying'];
export var EDUCATION_STATUS_LABELS = {
  Graduated: 'I have graduated',
  Studying: 'I am still studying'
};
export var Keys = {
  CefApplication: {
    applicationCompleteOnLoad: 'applicationCompleteOnLoad'
  },
  Application: {
    nationality: 'nationality',
    countryOfResidence: 'countryOfResidence',
    stateOfResidence: 'stateOfResidence',
    validStudyPermitsOrVisas: 'validStudyPermitsOrVisas',
    educationStatus: 'educationStatus',
    educationCountry: 'educationCountry',
    educationLevel: 'educationLevel',
    degree: 'degree',
    educationType: 'educationType',
    mostRecentOverallGrade: 'mostRecentOverallGrade',
    englishProficiencyTest: 'englishProficiencyTest',
    standardizedTests: 'standardizedTests',
    greTest: 'greTest',
    gmatTest: 'gmatTest'
  },
  ProgressData: {
    progress: 'progress',
    step: 'step'
  }
};
export var question4OptionKeys = {
  None: 'None'
};
export var Questions = (_Questions = {}, _defineProperty(_Questions, Keys.Application.nationality, {
  title: 'What is your nationality?',
  step: 1
}), _defineProperty(_Questions, Keys.Application.stateOfResidence, {
  title: 'What is your state of residence?',
  step: 2
}), _defineProperty(_Questions, Keys.Application.educationStatus, {
  title: 'What is your highest level of education?',
  step: 3
}), _defineProperty(_Questions, Keys.Application.mostRecentOverallGrade, {
  title: 'What is your most recent overall grade?',
  step: 4
}), _defineProperty(_Questions, Keys.Application.englishProficiencyTest, {
  title: 'Have you taken any English proficiency tests?',
  step: 5
}), _defineProperty(_Questions, Keys.Application.standardizedTests, {
  title: 'What standardized tests have you taken within the last 5 years?',
  step: 6
}), _Questions);
export var HeaderConstants = {
  CheckEligibility: 'Check Eligibility',
  CheckYourEligibility: 'Check Your Eligibility',
  FiveMins: '5 minutes',
  SixToEightQuestions: '6-8 questions',
  Description: 'Answer a few questions to get matched to your dream program.'
};
export var SaveAndExitContent = {
  Title: 'Save progress and finish later?',
  Description: 'Save your progress to continue where you leave off.',
  Warning: 'Please provide information on your highest level of education and grade before saving.'
};
export var EligibleWithCondition = 'You are eligible with a condition';
export var RestartProgressConstants = {
  TitleMobile: 'Check Your Eligibility',
  TitleDesktop: 'Check eligibility',
  Description: 'You have saved progress. You can pick up where you left off or restart your progress.'
};
export var Routes = {
  Results: '/results',
  RestartProgress: '/restart-progress',
  Eligibility: {
    CheckEligibilityIntro: '/',
    NationalityQuestion: '/m/1',
    CountryOfResidenceQuestion: '/m/2',
    ProvinceOfResidenceQuestion: '/m/3',
    HighestEducationQuestion: '/m/4',
    OverallGradeQuestion: '/m/5',
    EnglishTestsQuestion: '/m/6',
    GraduateTestsQuestion: '/m/7'
  },
  Preferences: {
    CountriesPage: '/onboarding_countries',
    EducationLevelFamiliesPage: '/onboarding_levels',
    FieldsOfEducationPage: '/onboarding_fields',
    BudgetPage: '/onboarding_budget',
    IntakesPage: '/onboarding_intakes'
  },
  ApplyBoost: {
    PathwayPage: '/applyboost_pathway',
    AdvisorConfirmationPage: '/advisor_confirmation'
  }
};
export var OnboardingFlowPages = [Routes.Preferences.CountriesPage, Routes.Preferences.EducationLevelFamiliesPage, Routes.Preferences.FieldsOfEducationPage, Routes.Preferences.BudgetPage, Routes.Preferences.IntakesPage, Routes.Eligibility.NationalityQuestion, Routes.Eligibility.CountryOfResidenceQuestion, Routes.Eligibility.ProvinceOfResidenceQuestion, Routes.Eligibility.HighestEducationQuestion, Routes.Eligibility.OverallGradeQuestion, Routes.Eligibility.EnglishTestsQuestion, Routes.Eligibility.GraduateTestsQuestion, Routes.ApplyBoost.PathwayPage];
export function isEligibilityQuestionPath(path) {
  return Object.values(Routes.Eligibility).includes(path);
}
export function isPreferenceQuestionPath(path) {
  return Object.values(Routes.Preferences).includes(path);
}
export var NO_RESULTS_FOUND = 'No Results Found';
export var OUTSIDE_INDIA = 'Outside India';
export var NAME_MAX_LENGTH = 50;
export var ErrorMessages = {
  REQUIRED_QUESTION: 'This question is required.',
  REQUIRED_FIELD: 'This field is required.',
  SELECT_VALID_COUNTRY: 'Please select a valid country.',
  SELECT_VALID_STATE: 'Please select a valid state.',
  SELECT_EDUCATION_LEVEL: 'Please select an education level.',
  SELECT_DEGREE: 'Please select a degree.',
  SELECT_EDUCATION_COUNTRY: 'Please select a country of education.',
  SELECT_OPTION: 'Please select an option.',
  TOEFL_SCORE: 'Please input a valid score between 0 and 30.',
  IELTS_SCORE: 'Please input a valid score between 1 and 9.',
  PTE_SCORE: 'Please input a valid score between 10 and 90.',
  DUOLINGO_SCORE: 'Please input a valid score between 10 and 160.',
  PERCENTILE_RANKING: 'Please input a valid percentile ranking.',
  VALID_SCORE: 'Please input a valid score between'
};
export var countries = {
  India: {
    name: 'India',
    code: 'IN'
  },
  Iran: {
    name: 'Iran',
    code: 'IR'
  },
  Nigeria: {
    name: 'Nigeria',
    code: 'NG'
  }
};
export var defaultPinnedCountries = [countries.India.name, countries.Iran.name, countries.Nigeria.name];
export var pinnedProvinces = ['Punjab', 'Gujarat', 'Haryana'];
export var commonName = 'commonName';
export var studyVisaTitle = 'studyVisaTitle';
export var id = 'id';
export var mediaQueryMaxWidth = 768;
export var placeholders = {
  country: 'Type a country',
  state: 'Type state of residence',
  educationCountry: 'Country of education',
  educationLevel: 'Education level',
  degree: 'Degree'
};
export var MINIMUM_DEGREE_FOR_STANDARDIZED_TESTS = 13;
export var BUTTON = {
  NEXT: 'Next',
  SHOW_RESULT: 'Show Result',
  SHOW_RESULTS: 'Show Results',
  EXPLORE_PROGRAMS: 'Explore Programs'
};
export var ELIGIBILITY = {
  NOT_ELIGIBLE: 'You are not eligible for this program at this time.',
  ELIGIBLE: 'You are eligible for this program.',
  WITH_CONDITION: 'You are eligible for this program with a condition.',
  NO_INTAKES: 'You are eligible for this program but there are no intakes currently available.'
};
export var PROGRAM_PAGE_ELIGIBILITY = {
  ELIGIBLE: ELIGIBILITY.ELIGIBLE,
  WITH_CONDITION: ELIGIBILITY.ELIGIBLE,
  NOT_ELIGIBLE: ELIGIBILITY.NOT_ELIGIBLE,
  NO_INTAKES: 'You are eligible, but there is no intake at this time',
  DEFAULT: 'Apply to this program'
};
export var NUMBER_OF_QUESTIONS = 6;
export var RESULT_PREREQUISITE_KEYS = [Keys.Application.nationality, Keys.Application.stateOfResidence, Keys.Application.educationStatus, Keys.Application.mostRecentOverallGrade, Keys.Application.englishProficiencyTest, Keys.Application.standardizedTests];
export var GradingSchemeType = {
  letter: 'letter',
  numerical: 'numerical',
  other: 'other'
};
export var GradingSchemeId = {
  other: 0
};
export var DSJ_ELIGIBILITY_RESULTS_HASH = '#dsj-eligibility-results';
export var CEF_CARD_WIDTH = '660px';